$(function() {

    //When print button clicked...
    $body.on('click', '.print-link', function(e) {
        e.preventDefault();
        window.print();
    });

});
